import axios from "axios";
import {baseUrl, auth, requestState} from "./utils";
import {showError} from "./error";

export const SET_SELECTED_ANNOUNCEMENT = "SET_SELECTED_ANNOUNCEMENT";
export const SET_LANDLORD_ANNOUNCEMENTS = "SET_LANDLORD_ANNOUNCEMENTS";
export const SET_ANNOUNCEMENT_LOAD_STATE = "SET_ANNOUNCEMENT_LOAD_STATE";
export const SET_ANNOUNCEMENT_STATE = "SET_ANNOUNCEMENT_STATE";
export const SET_INTEREST_REQUEST_STATE = "SET_INTEREST_REQUEST_STATE";
export const CLEAR_LANDLORD_DATA = "CLEAR_LANDLORD_DATA";
export const SET_ANNOUNCEMENT_LISTENER = "SET_ANNOUNCEMENT_LISTENER";

export function setSelectedAnnouncement(id) {
    return {
        type: SET_SELECTED_ANNOUNCEMENT,
        id: id
    }
}

export function setLandlordAnnouncements(announcements) {
    return {
        type: SET_LANDLORD_ANNOUNCEMENTS,
        announcements: announcements
    }
}

export function setAnnouncementLoadState(state) {
    return {
        type: SET_ANNOUNCEMENT_LOAD_STATE,
        state: state
    }
}

export function setAnnouncementState(state) {
    return {
        type: SET_ANNOUNCEMENT_STATE,
        state: state
    }
}

export function setInterestRequestState( state ) {
    return {
        type: SET_INTEREST_REQUEST_STATE,
        state: state
    }
}

export function clearLandlordData() {
    return {
        type: CLEAR_LANDLORD_DATA,
    }
}

export function setAnnoucementListener( listener ) {
    return {
        type: SET_ANNOUNCEMENT_LISTENER,
        listener: listener
    }
}

export function handleAnnouncementSelection( id ) { return ( dispatch, getState ) => {
    try {
        dispatch( setSelectedAnnouncement( id ) )
        const callback = getState().landlord.onAnnouncementSelection;
        if ( callback ) {
            console.log( "[:::CALLING LISTENER WITH:::]", id ); // DEBUG
            callback( id )
        }
    }
    catch ( error ) {
        console.log( "handleAnnouncementSelection - error:", error )
    }
} }

export function selectFirstAnnouncement() { return ( dispatch, getState ) => {
    try {
        const curr = getCurrentAnnouncement( getState() );
        if ( curr !== undefined ) {
            return curr;
        }
        const id = getState().landlord.announcements[0].id;
        dispatch( setSelectedAnnouncement( id ) );
    }
    catch ( error ) {

    }
} }

export function loadLandlordAnnouncements() {
    return async (dispatch, getState) => {
        try {
            dispatch( setAnnouncementLoadState( requestState.inProgress ) );
            dispatch(setLandlordAnnouncements([])); // Clear previous properties
            const user = getState().user.data;
            const res = await axios.get(`${baseUrl}/user/${user.id}/announcement`, auth(getState));
            const announcements = res.data || [];
            console.log(`GET ${baseUrl}/user/${user.id}/announcement response:`, announcements);
            dispatch(setLandlordAnnouncements(announcements));
            dispatch( selectFirstAnnouncement() );
            dispatch( setAnnouncementLoadState( requestState.ok ) );
        }
        catch( error ) {
            dispatch(showError(error.response&&error.response.data.message))
            dispatch( setAnnouncementLoadState( requestState.fail ) );
        }
    }
}

export function submitResidence(onSuccess, houseType, files, surroundFiles) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAnnouncementState(requestState.inProgress));
            let fileArray = [];
            if ( files ) {
                for ( let i = 0; i < files.length; i++ ) {
                    const file = files[i];
                    let formData = new FormData();
                    formData.append( "file", file );
                    const fileRes = await axios.post( `${baseUrl}/files`, formData, auth( getState ) );
                    console.log( 'POST /files response:', fileRes.statusText ); // DEBUG
                    fileArray.push( fileRes.data );
                }
            }
            if ( surroundFiles ) {
                for ( let i = 0; i < surroundFiles.length; i++ ) {
                    const file = surroundFiles[i];
                    let formData = new FormData();
                    formData.append( "file", file );
                    const fileRes = await axios.post( `${baseUrl}/files?surround=true`, formData, auth( getState ) );
                    console.log( 'POST /files?surround=true response:', fileRes.statusText ); // DEBUG
                    fileArray.push( fileRes.data );
                }
            }
            const residenceBody = {
                houseType: houseType,
                file: fileArray
            }
            const response = await axios.post(`${baseUrl}/residence`, residenceBody, auth(getState));
            console.log("POST /residence response:", response); // DEBUG
            if (onSuccess)
                onSuccess(response.data);
        }
        catch (error) {
            console.log("POST /residence error:", error);
            dispatch(showError(error.response.data.message))
            dispatch(setAnnouncementState(requestState.fail));
        }
    }
}

export function submitAnnouncement(residenceId, properties) {
    return (dispatch, getState) => {
        const announcementBody = {
            ...properties
        }
        axios.post(`${baseUrl}/announcement/residence/${residenceId}`, announcementBody, auth(getState))
            .then(response => {
                console.log(`POST /announcement/residence/${residenceId} response:`, response);
                dispatch(setAnnouncementState(requestState.ok));
            })
            .catch(error => {
                console.log(`POST /announcement/residence/${residenceId} error:`, error);
                dispatch(setAnnouncementState(requestState.fail));
                dispatch(showError(error.response.data.message))
            })
    }
}

export function toggleAnnouncement(anno) {
    return async (dispatch, getState) => {
        try {
            const body = {
                isActive: !anno.isActive
            }
            console.log("EDITING ANNOUNCEMENT >>", anno, "PATCH >>", body);
            const res = await axios.patch(`${baseUrl}/announcement/${anno.id}`, body, auth(getState));
            console.log(`PATCH /announcement/${anno.id} response:`, res); // DEBUG
            dispatch(loadLandlordAnnouncements());
        }
        catch (error) {
            console.log(`PATCH /announcement/${anno.id} error:`, error);
            dispatch(showError(error.response.data.message))
        }
    }
}

export function getCurrentAnnouncement( state ) {
    const announcements = state.landlord.announcements;
    const selected = state.landlord.selectedAnnouncement;
    if ( selected === undefined )
        return undefined;
    for ( let key in announcements ) {
        if ( announcements[key].id === selected ) {
            return announcements[key];
        }
    }
    return undefined;
}
